import { IUsershipPerson } from '@root/query'

/** is the given object a Function? */
// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (obj: unknown): obj is Function => typeof obj === 'function'

/** utility for calling all the provided arguments */
export const callAll =
  <GenericType>(...fns: Array<(...a: GenericType[]) => void>) =>
  (...args: GenericType[]): void =>
    fns.forEach(fn => fn && fn(...args))

export const handleOnEnterPress = (e: React.KeyboardEvent, callback: () => void): void => {
  if (e.key === 'Enter') {
    callback()
  }
}

export const capitalize = (s: string): string => {
  const [first, ...rest] = s
  return [first.toUpperCase(), ...rest].join('')
}

export const assertUnreachable = (message: string, value: never): void => {
  throw new Error(`Encountered unreachable entry: ${message} - ${value}`)
}

/**
 * Checks that the provided objects' contents are equal to each other.
 */
export const deepEqual = (x, y) => {
  const ok = Object.keys,
    tx = typeof x,
    ty = typeof y
  return x && y && tx === 'object' && tx === ty
    ? ok(x).length === ok(y).length && ok(x).every(key => deepEqual(x[key], y[key]))
    : x === y
}

export const createFullName = (user: IUsershipPerson): string => {
  return [user.first_name, user.last_name].join(' ').trim()
}

type DisplayNameParts = Partial<Record<'first_name' | 'last_name' | 'email', string | null>>

interface DisplayNameOptions {
  fallbackToEmail?: boolean
}

const normalizeDisplayValue = (value?: string | null): string | undefined => {
  if (typeof value !== 'string') {
    return undefined
  }

  const trimmedValue = value.trim()
  return trimmedValue || undefined
}

export const getUserDisplayName = (
  user?: DisplayNameParts | null,
  options: DisplayNameOptions = {}
): string | undefined => {
  const { fallbackToEmail = true } = options
  if (!user) {
    return undefined
  }

  const firstName = normalizeDisplayValue(user.first_name)
  const lastName = normalizeDisplayValue(user.last_name)
  const email = normalizeDisplayValue(user.email)

  const fullName = [firstName, lastName].filter(Boolean).join(' ')
  if (fullName) {
    return fullName
  }

  if (fallbackToEmail) {
    return email
  }

  return 'User'
}
